import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IQATestableProps } from '../../../shared/types/IQATestableProps';
import { OzIcon, ICON_TYPE } from '../../icon/Icon';
import { ICON_SIZE } from '../../icon/ICON_SIZE';
import styles from '../Collapse.module.css';
import { COLLAPSE_SIZES } from '../COLLAPSE_SIZES';

type CollapseIconProps = IQATestableProps & {
    isContentVisible: boolean;
    size: COLLAPSE_SIZES;
};

function getIconClassNames (isContentVisible: boolean): string {
    return classNames({
        [styles.icon]: true,
        [styles.expandIcon]: isContentVisible,
    });
}

function getIconSize (size: COLLAPSE_SIZES): ICON_SIZE {
    if (size === COLLAPSE_SIZES.SMALL) {
        return ICON_SIZE.SMALL;
    }

    return ICON_SIZE.MEDIUM;
}

function getIconAltText (isContentVisible: boolean): string {
    if (isContentVisible) {
        return 'Arrow-Up Icon';
    }

    return 'Arrow-Down Icon';
}

export function CollapseIcon (props: CollapseIconProps): ReactElement {
    const {
        'data-testid': dataTestId = '',
        isContentVisible,
        size,
    }: CollapseIconProps = props;

    const iconClasses: string = getIconClassNames(isContentVisible);
    const iconSize: ICON_SIZE = getIconSize(size);
    const alt: string = getIconAltText(isContentVisible);

    return (
        <OzIcon
            data-testid={dataTestId}
            className={`ml-1 ${iconClasses}`}
            type={ICON_TYPE.OZ_ARROW_DOWN}
            size={iconSize}
            alt={alt}
        />
    );
}
